const STORAGE_KEYS = {
  token: 'ss_jwt_token',
  refreshToken: 'ss_refresh_token',
  projectId: 'ss_project_id',
  apiUrl: 'ss_api_url',
  tokenApiUrl: 'ss_token_api_url',
} as const;

export type SavedConfig = {
  token: string;
  refreshToken: string;
  projectId: string;
  apiUrl: string;
  tokenApiUrl: string;
};

const read = (key: string): string => {
  const v = localStorage.getItem(key);
  if (v === null || v === 'undefined' || v === 'null') return '';
  return v;
};

export const loadSaved = (): SavedConfig => ({
  token: read(STORAGE_KEYS.token),
  refreshToken: read(STORAGE_KEYS.refreshToken),
  projectId: read(STORAGE_KEYS.projectId),
  apiUrl: read(STORAGE_KEYS.apiUrl) || 'http://localhost:5050',
  tokenApiUrl: read(STORAGE_KEYS.tokenApiUrl),
});

export const persistConfig = (
  token: string,
  refreshToken: string,
  projectId: string,
  apiUrl: string,
  tokenApiUrl: string,
): void => {
  localStorage.setItem(STORAGE_KEYS.token, token);
  localStorage.setItem(STORAGE_KEYS.refreshToken, refreshToken);
  localStorage.setItem(STORAGE_KEYS.projectId, projectId);
  localStorage.setItem(STORAGE_KEYS.apiUrl, apiUrl);
  localStorage.setItem(STORAGE_KEYS.tokenApiUrl, tokenApiUrl);
};
